/**
 * The two logo slots and their sizes (XN-4507). One table, read by the crop
 * (which draws a frame of this shape and renders a canvas at 2x of it) and by
 * the card (which labels the empty slot with it) — so the frame a person crops
 * into and the size the slot promises cannot disagree.
 */
export const SLOT_SHAPES = {
  wide: { width: 184, height: 48, outWidth: 368, outHeight: 96, label: 'full logo' },
  square: { width: 96, height: 96, outWidth: 192, outHeight: 192, label: 'collapsed logo' },
};
